import { render, staticRenderFns } from "./message-template.vue?vue&type=template&id=a7394270&"
import script from "./message-template.vue?vue&type=script&lang=js&"
export * from "./message-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports